/* Gurenta: animaciones de las secciones mt- (aparición, contadores, inclinación 3D) */
(function () {
  document.documentElement.classList.add('mt-js');
  function show(el) {
    el.classList.add('is-in');
    var n = el.querySelector('[data-mt-count]') || (el.hasAttribute('data-mt-count') ? el : null);
    if (n && !n.dataset.mtDone) { n.dataset.mtDone = '1'; count(n); }
  }
  function init(root) {
    var els = root.querySelectorAll('[data-mt-reveal]:not(.is-in)');
    // Lo que ya está en pantalla aparece al momento
    els.forEach(function (e) { if (e.getBoundingClientRect().top < window.innerHeight) show(e); });
    // Seguridad: si algo falla, todo se muestra a los 4 s
    setTimeout(function () { root.querySelectorAll('[data-mt-reveal]:not(.is-in)').forEach(show); }, 4000);
    els = root.querySelectorAll('[data-mt-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        show(en.target);
        io.unobserve(en.target);
      });
    }, { threshold: 0.18 });
    els.forEach(function (e) { io.observe(e); });

    root.querySelectorAll('[data-mt-tilt]').forEach(function (el) {
      if (el.dataset.mtTiltOn) return; el.dataset.mtTiltOn = '1';
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 10) + 'deg)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }
  function count(el) {
    var to = parseFloat(el.getAttribute('data-mt-count')) || 0, dur = 1400, t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur), v = to * (1 - Math.pow(1 - p, 3));
      el.textContent = Math.round(v);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
